<template>
    <button class="btn btn-success"
          @click.prevent="resetPassword()"><span class="icon icon-mail"> Send New Account Email</span>
        </button>
</template>

<script>
const items = [];
export default {
  props: ["user", "url"],
  methods: {
    resetPassword() {
      axios.get(this.url + this.user.id)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
            swal({
          title: "New Account Message Sent!",
          icon: "success"
        });
    },
  }
};
</script>